// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1AqwX","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__9Gw_h"};